import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LandingPage } from '@/pages/LandingPage';
import { ClientPage } from '@/pages/ClientPage';
import { PlacePage } from '@/pages/PlacePage';
import { ScanPage } from '@/pages/ScanPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { DisplayPage } from '@/pages/DisplayPage';
import { LoginPage } from '@/pages/LoginPage';
import { BusinessSetup } from '@/pages/BusinessSetup';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { BrandingWrapper } from '@/components/BrandingWrapper';
import { useBusiness } from '@/hooks/useBusiness';

function PublicLayout() {
  const { business } = useBusiness('demo');
  return (
    <BrandingWrapper business={business}>
      <Outlet />
    </BrandingWrapper>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="bottom-center"
        richColors
        toastOptions={{
          style: {
            background: 'var(--qr-surface)',
            color: 'var(--qr-text)',
            border: '1px solid var(--qr-border)',
          },
        }}
      />
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/s/:sessionId" element={<ClientPage />} />
          <Route path="/p/:placeId" element={<PlacePage />} />
          <Route path="/display/:businessId" element={<DisplayPage />} />
        </Route>

        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/scan"
          element={
            <ProtectedRoute>
              <ScanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/setup"
          element={
            <ProtectedRoute>
              <BusinessSetup />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
